import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { User } from '@app/core/domain';
import { UserStateInterface } from '@app/core/app-services';
import { UserStore } from './user.store';
import { UserQuery } from './user.query';

@Injectable()
export class UserState implements UserStateInterface {
  constructor(
    private store: UserStore,
    private query: UserQuery
  ) { }

  getUserSnapshot(): User {
    return this.query.getUserSnapshot();
  }

  getUser(): Observable<User> {
    return this.query.getUser();
  }

  isLoading(): Observable<boolean> {
    return this.query.isLoading();
  }

  userHasPlcCard(): Observable<boolean> {
    return this.query.userHasPlcCard();
  }

  setLoading(status: boolean = true): void {
    this.store.setLoading(status);
  }

  setState(user: User): void {
    this.store.update(state => ({ ...state, user, loading: false }));
  }

  setDateOfBirthStatus(status: boolean) {
    this.store.update(state => ({ ...state, hasDateOfBirth: status }));
  }

  setAgeVerifiedNegative(status: boolean) {
    this.store.update(state => ({ ...state, ageVerifiedNegative: status }));
  }

  hasDateOfBirth(): Observable<boolean> {
    return this.query.select(state => state.hasDateOfBirth)
      .pipe(
          filter((hasDateOfBirth?: boolean) => hasDateOfBirth !== null)
      );
  }

  ageVerifiedNegative(): Observable<boolean> {
    return this.query.select(state => state.ageVerifiedNegative)
      .pipe(
          filter((ageVerifiedNegative?: boolean) => ageVerifiedNegative !== null)
      );
  }

  setUserHasPlcCard(hasPlc: boolean): void {
    const user = this.getUserSnapshot();
    user.containsPlcCard = hasPlc;
    this.setState(user);
  }

  userHasMultiplePlcAccounts(): Observable<boolean> {
    return this.query.select(state => state.hasMultiplePlcAccounts);
  }

  setUserHasMultiplePlcAccounts(hasMultipleAccounts: boolean): void {
    this.store.update(state => ({ ...state, hasMultiplePlcAccounts: hasMultipleAccounts }));
  }

  userHasMultipleCardGroups(): Observable<boolean> {
    return this.query.select(state => state.hasMultiplePlcCardGroups);
  }

  setUserHasMultipleCardGroups(hasMultipleCardGroups: boolean): void {
    this.store.update(state => ({ ...state, hasMultiplePlcCardGroups: hasMultipleCardGroups }));
  }

  hasMarkedMarketingConsent(): Observable<boolean> {
    return this.query.select(state => state.hasMarkedMarketingConsent);
  }

  setMarkedMarketingConsent(marked: boolean): void {
    this.store.update(state => ({ ...state, hasMarkedMarketingConsent: marked }));
  }
}
